import { useTranslation } from 'react-i18next';
import './footer.scss';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <footer className="footer footer-3" id="contact">
            <div className="container-fluid map-image">
                <div className="row section-separator">
                    <div className="image-bg col-sm-12">
                        <div className="container mt-30">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="text-left text-xs-center">
                                                <p>
                                                    {t('Copyright')} &copy; 2019-{new Date().getFullYear()}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
